import { render, staticRenderFns } from "./TableListPages.vue?vue&type=template&id=b75f6070"
import script from "./TableListPages.vue?vue&type=script&lang=js"
export * from "./TableListPages.vue?vue&type=script&lang=js"
import style0 from "./TableListPages.vue?vue&type=style&index=0&id=b75f6070&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b75f6070')) {
      api.createRecord('b75f6070', component.options)
    } else {
      api.reload('b75f6070', component.options)
    }
    module.hot.accept("./TableListPages.vue?vue&type=template&id=b75f6070", function () {
      api.rerender('b75f6070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableListPages.vue"
export default component.exports